<template>
    <b-overlay :show="showoverlay" rounded="sm" class='demolistwrap'>
        <div class="card mt-0 border-0 bg-wash no-shadow demolistwrap2">

            <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin">
                    <div class="col-sm-6 pl-0" >                 
                        <div class="align-self-center custom-search pr-0 mt-2" style="max-width: 480px;">
                            <b-input-group >
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search by employee / position / code / branch / email / phone" v-model="search" @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <div class="col-sm-6 pr-0 trz_ppl_wrapper">
                        <div class="col-12 text-right pr-0 trz_ppl_wrapper_2">
            
                            
                            <b-button  id="filter_button" class="employee-filter-btn mb-1 custom-secodary-btn" v-b-toggle.sidebar_right>Filter<b-icon class="ml-3" icon="funnel-fill" ></b-icon></b-button>
                            <b-button v-if="switch_view==1" class="view-mode-btn employee-filter-btn mb-1 custom-secodary-btn switch-view-btn" @click="viewmode = !viewmode">Switch View<b-icon v-if="viewmode" class="ml-3 list-icon" icon="list-ul"></b-icon><b-icon v-else class="ml-3 grid-icon" icon="grid3x3-gap-fill"></b-icon></b-button>
                            <div class="d-inline-block trz_fields trz-custom-dropdown mb-1 position-absolute trz_people_btn" :class="email_class">
                                <div class="pl-0 company-employee-count" style="height: 31px; position: unset;"><span class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon"><b-icon class="" icon="people-fill"></b-icon></span><span class="text-center px-2 border d-inline-block h-100 employee-count-number" style="min-width: 51px;">{{people}}</span></div>
                            </div> 
                        
                        </div>
                    </div>
                </div>
            </div>        
   
            <div class="card-body px-0" :class="{'container' : is_company_directory != 'yes'}" >
                        
                    <div class="employee-table-wrapper" :class="[{ 'no-overflow' : paginatedData.length < 8 && is_pf!=1 }, tableStickyHeight]" v-if="viewmode">
                        <table class="employee-list-table dataTable table-overflow table-sticky" v-if="viewmode">
                            
                            <thead>
                                <tr class="table-head ">
                                    
                                    <td v-for="f in default_column">
                                        <template v-for="k in default_options">                                
                                            <template v-if="f == k.value  && f !='name'" >
                                                <label class="custom-label" :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"   @click="sortBy(k.value)">
                                                    <span><template v-if="k.text == 'Jobposition'">Job Position</template><template v-else-if="k.text == 'Branch'">Work Location</template><template v-else>{{k.text}}</template></span>
                                                </label>
                                            </template>
                                            <template v-if="f == k.value  && f =='name'" >
                                                <input v-if ="checkbox==1" type="checkbox" v-model="selectAll" class="">
                                                <label class="custom-label pl-5" :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"   @click="sortBy(k.value)">
                                                    <span>{{k.text}}</span>
                                                </label>
                                            </template>
                                        </template>
                                    </td>
                        
                                    
                                    
                                
                                    <td v-if="is_action==1" class="action_thead">Action</td>

                                </tr>
                            </thead>
                            <tbody>                            
                                <tr class="hover-bg table-row" v-for="employee in paginatedData" :key="employee[primary_key]">

                                    <td class="cursor-pointer trz_relative"   v-for="f in default_column">
                                        <template v-if="f == 'phone'"><span class="cursor-pointer" @click="editEmployee(employee[primary_key])">{{formatPhoneNumber(employee.phone)}}</span></template>
                                        <template v-else-if="f == 'name' ">
                                          
                                            <template v-if="checkbox==1 "><input v-if="employee.pay_slip_name && employee.pay_slip_name !=''" type="checkbox" class="justify-content-center" v-model="selected" :value="employee[primary_key]" number><input v-if="employee.locked ==1" type="checkbox" :disabled="employee.locked ==1" class="justify-content-center trz_disable_box" v-model="selected" :value="employee[primary_key]" number><input v-else type="checkbox" class="justify-content-center" v-model="selected" :value="employee[primary_key]" number></template>
                                            <label class="mb-0 custom-label">
                                                <img class="img-fluid img-thumbnail employee-avatar mx-2" style ="visibility: hidden;" /> 
                                                <template v-if="employee.pay_slip_name && employee.pay_slip_name !=''">
                                                    <span v-if="$acl['createpayslipbyid'] == 2" style="color: rgb(29, 104, 167);" class="cursor-pointer" @click="editEmployee(employee[primary_key])">{{employee.name}}</span>
                                                    <span v-else style="color: rgb(29, 104, 167);" class="">{{employee.name}}</span>
                                                </template>
                                                <template v-else>
                                                    <span class="cursor-pointer" @click="editEmployee(employee[primary_key])">{{employee.name}}</span>
                                                </template>
                                            </label>
                                        </template>
                                        <template v-else>{{employee[f]}}</template>
                                    </td>
                                    
                                   
                                    
                                    <td v-if="is_action==1 && employee.actions.length > 0" class="action_td">
                                        <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group >
                                                    <div v-for="(row, index) in employee.actions" :key="index">
                                                    <b-button variant="outline-secondary"  @click="actionEmployee(employee[primary_key],row.value)">
                                                    <b-icon v-if="row.label == 'Review'" icon="pencil-square"></b-icon>
                                                    <b-icon v-else-if="row.label == 'Preview Taxcard'" icon="eye"></b-icon>
                                                    <b-icon v-else-if="row.label == 'Locked'" icon="lock-fill"></b-icon>
                                                    
                                                    <b-icon v-else icon="gear"></b-icon>
                                                    {{row.label}}
                                                    </b-button>

                                                    </div>

                                                </b-button-group>
                                            </div>
                                        </div> 
                                    </td>
                                    <td v-else-if="is_action==1 && employee.actions.length == 0" class="action_td">
                                        <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                            
                                        </div> 
                                    </td>
                                    

                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--</div>-->
                <!--</div>-->
                <!-- list view ends here -->
                
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">                
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
                
                </div>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{blankmsg}}</span>
                    <img v-if="show_loader" v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
            </div>

            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <general-filter-list  :key="sidebar_key" :grid_options="grid_options" :search_by_filter="search_by_filter" :default_column="default_column"   v-on:childToParent="filterList"></general-filter-list>
            </b-sidebar>
            {{clickSelect}}
        </div>
        
    </b-overlay>
</template>


<script>
export default{
        props: ['grid_data','default_column','grid_options','primary_key','email_class','checkbox','is_action','is_pf','payslipids','switch_view','is_payruns','all_employee','is_company_directory','edit_icon'],        
        
        data(){

            let sortOrders = {};

            //columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {

                columns: [],
                sortKey: 'name',
                sortOrders: sortOrders,          
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},

                default_options: [],
                appended_options: [],              
                column_options:[],
                search_by_filter:[],
                selected: [],
                backdoor: 0,
                sidebar_key:0,
                selected_ids :[],
                showoverlay : true,
                viewmode :true,
                notice: "",
                blankmsg : 'Fetching data..',
                people:0,
                company_name : '',
                filter_by_id:['jobposition_id','department_id','branch_id'],
                search:'',
                length: 20,
                temp_length: 20,
                length_options: [],
                status_flag: false,
                show_loader: false,
                tableStickyHeight: '',
                
            }
        },
        methods:{            
            
            sortBy(key) 
            {                
                this.resetPagination();
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;

                this.backdoor++;
            },
            filterList(value)
            {
                console.log(value);
                this.resetPagination();
                if(value['reset'] == 1)
                {
                    this.search_by_filter = value['search_by_filter'];
                    this.sortBy('name');
                    $("#filter_button").click();

                    //this.resetFlter();
                }
            },
            
            stringView(str) {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            getIndex(array, key, value) 
            {
                return array.findIndex(i => i[key] == value)
            },
           

            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
        
            generateList: function()
            {

                this.showoverlay = false;
                if(this.grid_data.length>0)
                {
                    let cr = {};

                    this.grid_options.forEach(element => {

                        if(element.label=='jobposition')
                        {
                            cr['jobposition_id'] = '';
                        }
                        else if(element.label=='department')
                        {
                            cr['department_id'] = '';
                        }
                        else if(element.label=='branch') 
                        {
                            cr['branch_id'] = '';
                        }
                        else
                        {
                            cr[element.label] = '';
                        }
                        
                    });

                    this.search_by_filter = cr;
                    let co = [];                  
                    let cl = []; 
                    let dop = []; 
                    this.grid_options.forEach(element => {
                            
                            if(1)
                            {
                            cl = cl.concat([{ label: this.stringView(element.label) , name: element.label,type:element.type}]);
                            
                            if(!this.default_column.includes(element.label))
                            {
                                co = co.concat([{ text: this.stringView(element.label) , value: element.label }]);
                            }
                            if(this.default_column.includes(element.label))
                            {
                                dop = dop.concat([{ text: this.stringView(element.label) , value: element.label }]);
                            }
                            }
                            

        
                    }); 
                    let aop = [];
                    let aopcl = [];
                    
                    
                    this.appended_options = this.appended_options.concat(aop);
                    this.default_options = this.default_options.concat(dop);
                    this.column_options = this.column_options.concat(co);
                    this.columns = this.columns.concat(cl);          
                    this.columns = this.columns.concat(aopcl);                 
                    this.columns.forEach((column) => {this.sortOrders[column.name] = -1;});
                    if(this.grid_data.length == 0){
                        if(this.is_payruns == 'yes'){
                            this.blankmsg = "Loading relevent payslips...";
                            this.show_loader = true;
                        }else{
                            this.blankmsg = "Looks like there is no relevent data here.";
                            this.show_loader = false;
                        }
                    }
                    else
                    {
                        this.tableStickyHeight = 'table-sticky-height';
                        this.length_options = [{ value: 20, text: "20" },
                                            { value: 50, text: "50" },
                                            { value: 100, text: "100" },
                                            { value: 200, text: "200" }
                                        ]; 
                        this.people = this.grid_data.length;
                        this.sortBy('name');
                    }

                }
                else
                {
                    let dop = []; 
                    let cl = []; 
                    this.default_column.forEach(element => {
                        cl = cl.concat([{ label: this.stringView(element) , name: element }]);
                        dop = dop.concat([{ text: this.stringView(element) , value: element }]);
                    });
                    this.columns = this.columns.concat(cl);   
                    this.default_options = this.default_options.concat(dop); 
                    if(this.is_payruns == 'yes'){
                        this.blankmsg = "Loading relevent payslips...";
                        this.show_loader = true;
                    }else{
                        this.blankmsg = "Looks like there is no relevent data here.";
                        this.show_loader = false;
                    }
                }

                
            },
            editEmployee:function(em_id)
            {    
                let value = [];
                value[this.primary_key] = em_id;
                value['action_id'] = 0;
                value['selected'] = []; 
                value['column_selected'] = [];
                this.$emit('childToParent',value);
            },    
            actionEmployee:function(em_id,action_id)
            {    
                let value = [];
                value[this.primary_key] = em_id;
                value['action_id'] = action_id;
                value['selected'] = []; 
                value['column_selected'] = [];
                this.$emit('childToParent',value);
            }, 
            getPrimaryKey:function()
            {    
                return this.primary_key;
            },
            getDateObj(start_month)
            {       let str_month_arr = [];
                    var m_names = ['january', 'february', 'march', 
                            'april', 'may', 'june', 'july', 
                            'august', 'september', 'october', 'november', 'december'];

                            if(start_month.includes("-"))
                            {
                                 str_month_arr = start_month.split("-");
                            }
                            else
                            {
                                 str_month_arr = start_month.split(" ");
                            }
                    
                    var yr1   = parseInt(str_month_arr[1]);
                    var mt  = str_month_arr[0]; 
                    var mon1 = m_names.indexOf(mt);
                    var d1 = new Date(yr1, mon1).getTime();
                    return d1;
            },        
            
        },
        created: function(){
            if(this.all_employee == 'yes'){
                this.status_flag = true;
            }
                   
            this.generateList();

            
            
            $(window).on('load', function (e) {
                setTimeout(function(){
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if($('table.employee-list-table').width() > $('.wrapper1').width()){
                        //alert($('table.employee-list-table').width());
                        $('.wrapper1').show();
                    }else{
                        //alert('Its not bigger');
                        $('.wrapper1').hide();
                    }
                }, 2000);
                $('.wrapper1').on('scroll', function (e) {
                    $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
                }); 
                $('.wrapper2').on('scroll', function (e) {
                    $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
                });
                
                $(document).on("click",".trz-custom-dropdown .custom-switch input",function() {
                    setTimeout(function(){
                        $('.div1').width($('table.employee-list-table').width());
                        $('.div2').width($('table.employee-list-table').width());
                        if($('table.employee-list-table').width() > $('.wrapper1').width()){
                            $('.wrapper1').show();
                        }else{
                            $('.wrapper1').hide();
                        }
                    }, 500);
                });
            });
            
        },
        computed: 
        {
            filteredData() 
            {
                this.backdoor;
            
                //alert(this.backdoor);
                
                let filtered_list = this.grid_data;

                let search_by_custom_fields = this.search_by_filter;

                var search_terms = new Array();

                Object.keys(search_by_custom_fields).forEach(key => {
                    
                    if(search_by_custom_fields[key] != '' && (this.default_column.includes(key) || this.filter_by_id.includes(key)))
                    {
                        search_terms.push(`${key}:${search_by_custom_fields[key]}`);
                    }
                    else 
                    {                        
                        this.search_by_filter[key] = '';
                    }
                    if(this.all_employee == 'yes')
                    {
                         if(search_by_custom_fields['status'] == '' && key=='status')
                         {
                                console.log(key);
                                search_terms.push('status:Active');
                         }
                    }

                    /* issue

                    if(this.status_flag)
                    {
                        search_terms.push('status:Active');
                    }

                    */
                });

                console.log(search_terms);
                
                if(search_terms.length>0)
                {   
                    
                    
                    for (var i = 0; i < search_terms.length; i++) {
                        const term_to_search = search_terms[i].split(":");
                        let search_key = term_to_search[0];
                        let search_value =  term_to_search[1];
                        
                        if(search_key == 'status')
                        {
                            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) == 0;})});
                        }
                        else
                        {
                            filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) > -1;})});
                        }
                        
                        }
                        console.log(filtered_list.length);

                    this.pagination.currentPage = 1;
                    if(filtered_list.length == 0)
                    {

                        this.blankmsg = "Nothing found.";

                        if(this.all_employee == 'yes')
                        {
                            if(this.search_by_filter['status']=='' || this.search_by_filter['status']=='Active')
                            {
                                console.log('No active employee found.');
                                this.blankmsg = "No active employee found.";
                            }
                            
                        }

                    }
                        
                        
                    if(this.all_employee == 'yes'){
                        //console.log(filtered_list);
                        if(filtered_list.length > 0){
                            if(filtered_list[0]['status'] && filtered_list[0]['status'] != ''){
                                console.log('Bujhlssam na');
                                console.log(filtered_list[0]['status']);
                                this.status_flag = false;
                            }else{
                                this.status_flag = true;
                            }
                        }
                    }
                }


                if (this.search) 
                {
                    
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                    
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                       
                }

                let sortKey = this.sortKey;

                //if(typeof this.sortOrders[sortKey] == 'undefined')this.sortOrders[sortKey] = -1;
                //else this.sortOrders[sortKey] = 1;

                let order = this.sortOrders[sortKey] || 1;

                //alert(sortKey + ' >> ' + order);

                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();

                            if (this.columns[index].type && this.columns[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            if (this.columns[index].type && this.columns[index].type === 'monthyear') 
                            {
                                return (a === b ? 0 : this.getDateObj(a) > this.getDateObj(b)  ? 1 : -1) * order;
                            } 
                            
                            else if (this.columns[index].type && this.columns[index].type === 'number') 
                            {
                                a = this.toMoney(a);
                                b = this.toMoney(b); 
                                
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                let aa = (a === b ? 0 : a > b ? 1 : -1) * order;
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                this.people = filtered_list.length;
                return filtered_list;
            },
            paginatedData() 
            {     
                this.backdoor;
                
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            selectAll: {
                get: function () {
                    return this.paginatedData ? this.selected.length == this.paginatedData.length : false;
                },
                set: function (value) {
                    var selected = []; 
                    var pm_key = this.getPrimaryKey();
                    console.log(pm_key);
                    if (value) {
                        this.paginatedData.forEach(function (user) {
                            if(user.pay_slip_name && user.pay_slip_name !='')
                                selected.push(user.id);
                            else
                            {
                                if(user.locked!=1)
                                {
                                    selected.push(user[pm_key]);
                                }
                                
                            }
                                
                        });
                    } 
                    this.selected = selected;
                }
            },
            clickSelect() 
            {    
                
                if(this.selected.length !=  this.selected_ids.length)
                {
                    this.selected_ids = this.selected;
                    let value = [];
                    value[this.primary_key] = 0;
                    value['action_id'] = 0; 
                    value['selected'] = this.selected; 
                    value['column_selected'] = [];
                    this.$emit('childToParent',value); 
                }
            },
        }
    }
</script>
<style>

.employee-list-table tr td:last-child {
	padding-right: 20px;
}
.action_thead {
	text-align: right;
}
.trz_disable_box + label::before {
	background: #adb5bdab !important;
}

.trz_people_btn.trz_email{
	right: 0;
	top: -185px;
}
.trz_employee_draft_edit {
	position: absolute;
	left: 12px;
	top: 18px;
}
.trz_relative {
	position: relative;
}
</style>
 
